import { useIntl } from 'react-intl';
import { useNavigate, useParams } from 'react-router-dom';

import { getProjectAccuracyPath, getProjectsBasePath } from '@verantos-dev/core-constants';
import { DataReliabilityPageTab } from '@verantos-dev/core-enums';
import { useGetProjectQuery } from '@verantos-dev/data-access-projects';
import { PageHeaderBreadcrumb } from '@verantos-dev/shared-components';
import { type PageTabProps } from '@verantos-dev/shared-components';

export const useDataReliabilityPageHeader = (): {
  breadcrumbs: PageHeaderBreadcrumb[] | undefined;
  pageTabs: PageTabProps[];
  messages: { [key: string]: string };
} => {
  const intl = useIntl();
  const navigate = useNavigate();

  const { projectId } = useParams();
  const { data: projectData } = useGetProjectQuery(projectId || '', { skip: !projectId });

  const messages = {
    pageTitle: intl.formatMessage({
      id: 'dataReliability.dataReliabilityPage.breadcrumbs.dataReliability',
    }),
    accuracyTitle: intl.formatMessage({
      id: 'dataReliability.dataReliabilityPage.pageTabs.accuracy',
    }),
    accuracyDesc: intl.formatMessage({
      id: 'dataReliability.dataReliabilityPage.pageTabs.accuracyDesc',
    }),
  };

  const breadcrumbs: PageHeaderBreadcrumb[] | undefined =
    projectData?.data.projectName && projectId
      ? [
          {
            label: intl.formatMessage({
              id: 'projects.cohortsListPage.breadcrumbs.projects',
            }),
            onClick: () => navigate(getProjectsBasePath()),
          },
          {
            label: projectData.data.projectName || '',
            onClick: () => {
              const currentPath = window.location.pathname;
              const projectAccuracyPath = getProjectAccuracyPath(projectId);

              // Prevent navigation if already on the project accuracy page
              if (!projectAccuracyPath.includes(currentPath)) {
                navigate(projectAccuracyPath);
              }
            },
          },
          {
            label: intl.formatMessage({
              id: 'dataReliability.dataReliabilityPage.breadcrumbs.dataReliability',
            }),
          },
        ]
      : undefined;

  const pageTabs: PageTabProps[] = [
    {
      id: DataReliabilityPageTab.accuracy,
      label: DataReliabilityPageTab.accuracy.toUpperCase(),
      isActive: true,
      path: getProjectAccuracyPath(projectId || ''),
      disabled: false,
    },
    {
      id: DataReliabilityPageTab.completeness,
      label: DataReliabilityPageTab.completeness.toUpperCase(),
      isActive: false,
      path: '',
      disabled: true,
    },
    {
      id: DataReliabilityPageTab.traceability,
      label: DataReliabilityPageTab.traceability.toUpperCase(),
      isActive: false,
      path: '',
      disabled: true,
    },
  ];

  return {
    breadcrumbs,
    pageTabs,
    messages,
  };
};
